import * as React from 'react';
import { SelectedFilters as SKSelectedFilters } from 'searchkit/es';
import { SelectedFilter as SelectedFiltersComponent } from '../../components';

export const SelectedFilters: React.FC = () => (
  <SKSelectedFilters itemComponent={SelectedFiltersComponent} />
);
